import React, { Component } from 'react'
import { Switch, FormControlLabel, CircularProgress } from '@material-ui/core'
import { create, list } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class ScreenPermissions extends Component {
  state = {
    accountsettings: this.props.accountsettings,
    inbox: this.props.inbox,
    campaigns: this.props.campaigns,
    tasks: this.props.tasks,
    templates: this.props.templates,
    forms: this.props.forms,
    contacts: this.props.contacts,
    contactgroups: this.props.contactgroups,
    urls: this.props.urls,
    files: this.props.files,
    knowledge: this.props.knowledge,
    phones: this.props.phones,
    loading: false,
  }

  componentDidMount() {
    if (!this.props.listView) {
      this.props
        .list('screenpermissions', null, `${DATA_API_URL}/screenpermissions`)
        .then(() => this.setState({ loading: false }))
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.accountsettings !== this.props.accountsettings) {
      this.setState({ accountsettings: this.props.accountsettings })
    }

    if (prevProps.inbox !== this.props.inbox) {
      this.setState({ inbox: this.props.inbox })
    }

    if (prevProps.campaigns !== this.props.campaigns) {
      this.setState({ campaigns: this.props.campaigns })
    }

    if (prevProps.tasks !== this.props.tasks) {
      this.setState({ tasks: this.props.tasks })
    }

    if (prevProps.templates !== this.props.templates) {
      this.setState({
        templates: this.props.templates,
      })
    }

    if (prevProps.forms !== this.props.forms) {
      this.setState({
        forms: this.props.forms,
      })
    }

    if (prevProps.contacts !== this.props.contacts) {
      this.setState({
        contacts: this.props.contacts,
      })
    }

    if (prevProps.contactgroups !== this.props.contactgroups) {
      this.setState({
        contactgroups: this.props.contactgroups,
      })
    }

    if (prevProps.urls !== this.props.urls) {
      this.setState({
        urls: this.props.urls,
      })
    }

    if (prevProps.files !== this.props.files) {
      this.setState({
        files: this.props.files,
      })
    }

    // if (prevProps.phones !== this.props.phones) {
    //   this.setState({
    //     phones: this.props.phones,
    //   })
    // }

    if (prevProps.files !== this.props.files) {
      this.setState({
        knowledge: this.props.knowledge,
      })
    }
  }

  handlePermissionChange = (screen, checked) => {
    const newPermissions = {
      ...this.state,
      [screen]: checked,
    }

    delete newPermissions.loading

    this.setState(newPermissions)

    this.props.create({
      entityType: 'screenpermissions',
      entity: {
        id: `screenpermissions-${this.props.username}-${this.props.vr_account_id}`,
        permissions: newPermissions,
      },
      url: `${DATA_API_URL}/screenpermissions`,
      hasSchema: false,
      snackbarMessage: 'none',
    }) // call create method from actions/data.js with updated permissions object
  }

  render() {
    const defaultScreens = [
      { label: 'Account Settings', value: 'accountsettings' },
      { label: 'Inbox', value: 'inbox' },
      { label: 'Campaigns', value: 'campaigns' },
      { label: 'Tasks', value: 'tasks' },
      { label: 'Templates', value: 'templates' },
      { label: 'Forms', value: 'forms' },
      { label: 'Contacts', value: 'contacts' },
      { label: 'Contact Groups', value: 'contactgroups' },
      { label: 'Short URLs', value: 'urls' },
      { label: 'Public Files', value: 'files' },
      { label: 'Knowledge', value: 'knowledge' },
    ]

    const screens = [...defaultScreens]

    return this.state.loading ? (
      <CircularProgress />
    ) : (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {screens.map(screen => (
          <FormControlLabel
            key={screen.value}
            control={
              <Switch
                checked={
                  typeof this.state?.[screen.value] === 'undefined'
                    ? true
                    : this.state?.[screen.value]
                }
                onChange={(event, checked) =>
                  this.handlePermissionChange(screen.value, checked)
                }
              />
            }
            label={screen.label}
            style={{ margin: '10px' }}
          />
        ))}
      </div>
    )
  }
}

export default connect(
  (state, { username }) => {
    const vr_account_id =
      state.auth?.session?.idToken?.payload?.['custom:vr_account_id']

    return {
      ...(state.data?.screenpermissions?.[
        `screenpermissions-${username}-${vr_account_id}`
      ]?.permissions || {}),
      vr_account_id,
    }
  },
  dispatch => bindActionCreators({ create, list }, dispatch),
)(ScreenPermissions)
